import { render, staticRenderFns } from "./DashboardComercioSeleccionable.vue?vue&type=template&id=0d095a42&scoped=true&"
import script from "./DashboardComercioSeleccionable.vue?vue&type=script&lang=js&"
export * from "./DashboardComercioSeleccionable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardComercioSeleccionable.vue?vue&type=style&index=0&id=0d095a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d095a42",
  null
  
)

export default component.exports